export default __webpack_public_path__ + "static/media/logo.5e685b6e.png";